/* eslint-disable */
import * as React from "react";
import ReportsProvider from "./ReportsProvider";
import Layout from "../../layouts/Layout";
import { useReportId } from "./shared";

import { createStyles } from "@material-ui/styles";
import { Theme, makeStyles } from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      flex: "1 1 auto",
      background: theme.palette.common.white,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingTop: 64,
      height: "100%",
      paddingBottom: 50,
    },
  });

const useStyles = makeStyles(styles);

export default function (props: { router: React.ReactNode }) {
  const reportId = useReportId();
  const classes = useStyles();
  const { router } = props;
  window["exportMode"] = true;

  return (
    <Layout isExport>
      <div className={classes.root}>
        <ReportsProvider reportId={reportId}>{router}</ReportsProvider>
      </div>
    </Layout>
  );
}
